import { IonContent, IonIcon, IonTextarea, IonAccordion, IonAccordionGroup, IonItem, IonLabel, IonFab, IonButton, IonFabButton, IonFabList, IonPopover, IonList, IonInput, IonModal, IonHeader, IonToolbar, IonButtons, IonTitle } from '@ionic/react';
import { useParams } from 'react-router';
import React, { useState, useRef, useEffect, lazy } from 'react';
import { bonfire, people, videocam, apps, checkmarkCircleOutline, add, happy, happyOutline, colorPalette, globe } from 'ionicons/icons'

import backend from '@/controllers/backend'
import prefs from '@/controllers/preferences'
//import RoleSelector from './RoleSelector';

const RoleSelector = lazy(() => import('./RoleSelector'))
const Message = lazy(() => import('@/components/Chat/Message'))
//import { type Message } from '@/components/Chat/Message'

//import Message from '@/components/Chat/Message'
import LLMTimings from '@/components/Chat/LLMTimings';
import LLMReplyCollector from '@/components/Chat/LLMReplyCollector';
import tts from '@/components/Chat/TTS';

import { getResponse } from '@/controllers/llm';

import { makePrompt } from '@/controllers/agent';
//import { sleep } from '@/controllers/llm_client';

import TTS from '@/components/Chat/TTS';
const Footer = lazy(() => import('./Footer'))
//import Footer from './Footer';
import Call from './Call'
//import Jupyter from '@/controllers/Jupyter';
import { type IKernelConnection } from '@jupyterlab/services/lib/kernel/kernel';
import xterm from '@/controllers/markdown/xterm'

import useQueryParams from "@/controllers/useQueryParams";
import AvatarSettings from './AvatarSettings';

interface Props {
  lesson: any
}

const Lesson: React.FC<Props> = ({ lesson }) => {
  const { doc_id, doc_name, chapter_lesson_id } = useParams();

  const [chapter_id, lesson_id] = chapter_lesson_id.split("_")

  const started = useRef(false);
  const [title, setTitle] = useState(''+doc_name+': '+chapter_id+'.'+lesson_id)
  const role = useRef(-1)

  const params = useParams()
  useEffect(() => {
    setTitle(lesson.title)
  }, [params, lesson])

  const jupyter = useRef<IKernelConnection>(null);

  useEffect(() => {
      if (started.current) return;
      started.current = true;

      // load previous chat
      {
        const savedChatId = query.get('chatId')
        if (!savedChatId) return;
        setChatId(savedChatId);

        // load saved chat from server
        (async () => {
          const savedMessages = await backend.chat_get(savedChatId);
          if (!savedMessages) return;
          //console.log("savedMessages", savedMessages);
          setMessages(savedMessages);
        })();
      }

      //jupyter_demo()
      if (tts.state.enabled)
        tts.speak(opener);
  })

  const live2dRef = useRef<HTMLCanvasElement>(null);

  const onNextRole = async () => {
    let nextRoleName = '';
    do {
      const savedRoles = await prefs.get('conversationRoles');

      const nextIdx = (role.current + 1) % savedRoles.length;

      const nextRoleObj = savedRoles[nextIdx];
      role.current = nextIdx
      nextRoleName = nextRoleObj.name
    } while (nextRoleName == 'User') // skipping user (legacy)

    return nextRoleName
  }

  // chat stuff
  const [query, setQuery] = useQueryParams(); // query params would contain chatId
  const [chatId, setChatId] = useState(null)
  const [lastFreeMsgId, setLastFreeMsgId] = useState<number>(3)
  const [messages, setMessages] = useState<Message[]>([{
    id: 2,
    role: "Greeter",
    type: "md",
    content: lesson.opener,
    timestamp: new Date().toISOString()
  }]);

  useEffect(() => {
    if (chatId) setQuery({ chatId })
  }, [chatId])

  useEffect(() => {
    // update opener
    setMessages((messages) => {
      const new_msgs = [...messages]
      new_msgs[0].content = lesson.opener
      return new_msgs
    })
  }, [lesson])

  const llmReplyCollector = useRef(new LLMReplyCollector());
  const llmTimings = useRef(new LLMTimings());

  Call.handlers.onSpeechEnd = async (audio, text) => {
    const msgId = await saveMessage("text", text);
    let newChatId = await backend.chat_save(messages, chatId, doc_id, chapter_lesson_id)
    newChatId = await backend.save_voice_msg(newChatId, msgId, audio)
    setChatId(newChatId)
  }

  const [videoCallStatus, setVideoCallStatus] = useState<'idle' | 'connecting' | 'active'>('idle');

  // scroll into view
  const messagesEndRef = useRef<HTMLDivElement>(null);
  function scrollToBottom() {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    setTimeout(() => {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }, 100);
  }

  const shouldSaveMessages = useRef(false);
  useEffect(() => {
    if (!shouldSaveMessages.current) return;
    (async () =>
      setChatId(await backend.chat_save(messages, chatId, doc_id, chapter_lesson_id))
    )();
  }, [messages])

  async function saveMessage(type: string, text: string) {
    const Live2D = await import('@/controllers/Live2D');
    Live2D.default.randomMotion();
    const id = lastFreeMsgId;
  
    const newMsgs = [...messages, {
      id: id,
      role: "User",
      type: type,
      content: text,
      timestamp: new Date().toISOString()
    } as Message]

    setLastFreeMsgId(x => ++x)
    setMessages(newMsgs)
    setChatId(await backend.chat_save(newMsgs, chatId, doc_id, chapter_lesson_id))

    scrollToBottom();

    if (type === "md" || type === "text") {
      // always run any python blocks user might include in markdown
      await runPythonBlocks(text)
      const { reply, role } = await requestLLMReply(newMsgs);
      await runPythonBlocks(reply)
    } else if (type == "py") {
      await requestJupyterReply(text)
    }

    shouldSaveMessages.current = true;
    // setTimeout(() => {
    //   console.log(messages)
    // }, 2000)

    // FIXME: this doesn't work at all
    //setTimeout(async () => {
    // a hack??
    // setMessages((m) => {
    //   (async () => {
    //     setChatId(await backend.chat_save(messages, chatId, doc_id, chapter_lesson_id))
    //   })();
    //   return m;
    // })
      
    //}, 1000);

    scrollToBottom();
  
    return id;
  }

  async function requestLLMReply(newMsgs: Message[]) {
    let newRole = await onNextRole();
    const language = await prefs.get_language();
    let prompt = makePrompt(lesson, newRole, language, newMsgs)

    if (!llmReplyCollector.current.llmRunning) {
      // debounce llm so that student can submit a ton of messages but llm is not
      // called multiple times
      llmReplyCollector.current.llmRunning = true;

      llmTimings.current.inferenceStart();
      let reply = ''
      while (true) {
        reply = await getResponse(prompt);
        if (reply !== '...' && reply !== 'SKIP TURN') break;
        newRole = await onNextRole();
        prompt = makePrompt(lesson, newRole, language, newMsgs)
      }

      const messegeReply = {
        id: lastFreeMsgId,
        role: newRole,
        type: "md",
        content: reply,
        timestamp: new Date().toISOString(),
        first_token_time: llmTimings.current.firstTokenDelta,
        total_reply_time: llmTimings.current.responseTime,
        num_tokens: llmTimings.current.numTokens
      } as Message
      setLastFreeMsgId(x => ++x)
      setMessages((messages) => [...messages, messegeReply]);

      if (tts.state.enabled)
        tts.speak(reply);

      scrollToBottom();
      // in case there are any images
      setTimeout(() => {
        scrollToBottom();
      }, 1000);
      setTimeout(() => {
        llmReplyCollector.current.llmRunning = false;
      }, 700);

      return {reply, role: newRole}
    }
    return {reply: "", role: ""}
  }

  async function runPythonBlocks(text: string) {
    const matched = text.matchAll(/```python\n(.+?)```/gms)
    // NOTE: forEach doesn't work on old amazon kindle tablet
    for (const m of matched) requestJupyterReply(m[1]);
    return Array.from(matched).length
  }

  async function requestJupyterReply(code: string) {
    if (!jupyter.current) {
      // TODO: only start jupyter when first message is sent
      // also, reconnect jupyter not just when it's needed but when any other user activity is
      // detected (new messages for example)
      // maybe even send some dummy code on every message to prevent kernel from being pruned
      const Jupyter = await import('@/controllers/Jupyter')
      jupyter.current = await Jupyter.default.startKernel();
    }
    console.log("code", code, jupyter.current)

    llmTimings.current.inferenceStart();
    const Jupyter = await import('@/controllers/Jupyter')
    let results = await Jupyter.default.executeCode(jupyter.current, code)
    //console.log(results)
    if (!results) {
      // kernel is disposed

      // FIXME: This assumes that current code doesn't depend on the previous code,
      // might need to re-run previous cells
      jupyter.current = await Jupyter.startKernel();
      results = await Jupyter.default.executeCode(jupyter.current, code)
    }


    //window.results = results;
    console.log(results)

    // TODO: we should be able to combine several messages into one
    let newMsgs: Message[] = []
    let msgId = 0;
    for (const result of results) {
      if (result.header.msg_type === "execute_result") {
        const {newMsgs: newMsgsPartial, msgId: msgIdPartial} = processExecuteResult(result)
        newMsgs = newMsgs.concat(newMsgsPartial)
        msgId += msgIdPartial
      } else if (result.header.msg_type === "display_data") {
        const {newMsgs: newMsgsPartial, msgId: msgIdPartial} = processExecuteResult(result)
        newMsgs = newMsgs.concat(newMsgsPartial)
        msgId += msgIdPartial
      } else if (result.header.msg_type === "error") {
        const {newMsgs: newMsgsPartial, msgId: msgIdPartial} = await processExecuteError(result)
        newMsgs = newMsgs.concat(newMsgsPartial)
        msgId += msgIdPartial
      } else if (result.header.msg_type === "stream") {
        const {newMsgs: newMsgsPartial, msgId: msgIdPartial} = processStream(result)
        newMsgs = newMsgs.concat(newMsgsPartial)
        msgId += msgIdPartial
      }
    }
    setLastFreeMsgId(x => x + msgId)
    setMessages((messages) => [...messages, ...newMsgs]);
  }

  function processExecuteResult(result) {
    const newMsgs: Message[] = []
    let msgId = 0;
    const text_plain = result.content.data["text/plain"]
    if (text_plain) {
      newMsgs.push({
        id: lastFreeMsgId + msgId,
        role: "Jupyter (text/plain)",
        type: "text",
        content: text_plain,
        timestamp: new Date().toISOString(),
        first_token_time: llmTimings.current.firstTokenDelta,
        total_reply_time: llmTimings.current.responseTime,
        num_tokens: llmTimings.current.numTokens
      } as Message)
      msgId += 1;
    }

    const text_markdown = result.content.data["text/markdown"]
    if (text_markdown) {
      newMsgs.push({
        id: lastFreeMsgId + msgId,
        role: "Jupyter (text/markdown)",
        type: "md",
        content: text_markdown,
        timestamp: new Date().toISOString(),
        first_token_time: llmTimings.current.firstTokenDelta,
        total_reply_time: llmTimings.current.responseTime,
        num_tokens: llmTimings.current.numTokens
      } as Message)
      msgId += 1;
    }

    const image_png = result.content.data["image/png"]
    if (image_png) {
      const url = `data:image/png;base64,${image_png}`
      newMsgs.push({
        id: lastFreeMsgId + msgId,
        role: "Jupyter (image/png)",
        type: "image",
        content: url,
        timestamp: new Date().toISOString(),
        first_token_time: llmTimings.current.firstTokenDelta,
        total_reply_time: llmTimings.current.responseTime,
        num_tokens: llmTimings.current.numTokens
      } as Message)
      msgId += 1;
    }

    const image_svg = result.content.data["image/svg+xml"]
    if (image_svg) {
      newMsgs.push({
        id: lastFreeMsgId + msgId,
        role: "Jupyter (image/svg+xml)",
        type: "html",
        content: image_svg,
        timestamp: new Date().toISOString(),
        first_token_time: llmTimings.current.firstTokenDelta,
        total_reply_time: llmTimings.current.responseTime,
        num_tokens: llmTimings.current.numTokens
      } as Message)
      msgId += 1;
    }

    const text_html = result.content.data["text/html"]
    if (text_html) {
      newMsgs.push({
        id: lastFreeMsgId + msgId,
        role: "Jupyter (text/html)",
        type: "html",
        content: text_html,
        timestamp: new Date().toISOString(),
        first_token_time: llmTimings.current.firstTokenDelta,
        total_reply_time: llmTimings.current.responseTime,
        num_tokens: llmTimings.current.numTokens
      } as Message)
      msgId += 1;
    }

    return {newMsgs, msgId}
  }

  async function processExecuteError(result) {
    const newMsgs: Message[] = []
    let msgId = 0;

    const c = result.content;
    //let msgText = `${c.ename}: ${c.evalue}\n`
    const msgText = await xterm.serialize(c.traceback.join('\n\r'))

    newMsgs.push({
      id: lastFreeMsgId + msgId,
      role: "Jupyter (error)",
      type: "error",
      content: msgText,
      timestamp: new Date().toISOString(),
      first_token_time: llmTimings.current.firstTokenDelta,
      total_reply_time: llmTimings.current.responseTime,
      num_tokens: llmTimings.current.numTokens
    } as Message)
    msgId += 1;

    return {newMsgs, msgId}
  }

  function processStream(result) {
    const newMsgs: Message[] = []
    let msgId = 0;

    const c = result.content;
    const name = c.name;
    const msgText = c.text;
    if (!msgText) {
      return {newMsgs, msgId}
    }

    newMsgs.push({
      id: lastFreeMsgId + msgId,
      role: `Jupyter (stream/${name})`,
      type: "text",
      content: msgText,
      timestamp: new Date().toISOString(),
      first_token_time: llmTimings.current.firstTokenDelta,
      total_reply_time: llmTimings.current.responseTime,
      num_tokens: llmTimings.current.numTokens
    } as Message)
    msgId += 1;

    return {newMsgs, msgId}
  }

  const videoCallRef = useRef<HTMLButtonElement>(null);

  const toggleVideoCallOff = async () => {
    if (videoCallStatus == "idle") return;
    await Call.toggleSTToff()
    const Live2D = await import('@/controllers/Live2D');
    if (Live2D.default.isRunning()) Live2D.default.stop();
    setVideoCallStatus('idle');
  }

  const toggleVideoCallOn = async () => {
    setVideoCallStatus('connecting');
    const Live2D = await import('@/controllers/Live2D');
    await Live2D.default.start(live2dRef.current!)
    await Call.toggleSTTon();
    setVideoCallStatus('active');

    setShowAvatarCanvas(true);
  }

  // FIXME: this doesn't do anything!
  useEffect(() => {
    return () => { toggleVideoCallOff() }
  }, [])

  const toggleVideoCall = async () => {
    if (videoCallStatus === 'idle') {
      await toggleVideoCallOn()
    } else if (videoCallStatus === 'active') {
      await toggleVideoCallOff()
      setShowAvatarCanvas(true);
    }
  };

  // speech skip button
  const [modelSpeaking, setModelSpeaking] = useState(false);
  useEffect(() => {
    TTS.state.onSpeechStart = () => { setModelSpeaking(true) };
    TTS.state.onSpeechEnd = () => { setModelSpeaking(false) };

    return () => {
      TTS.state.onSpeechStart = () => {};
      TTS.state.onSpeechEnd = () => {};
    }
  }, [])


  const avatarMenuRef = useRef<HTMLIonModalElement>(null);
  const [showAvatarCanvas, setShowAvatarCanvas] = useState(false);
  return (<>
  <IonContent fullscreen>
    <div className="max-w-4xl mx-auto p-4">
      <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-6">{title}</h2>
      <IonAccordionGroup className="rounded-lg overflow-hidden shadow-md">
        <IonAccordion value="prompt-editor">
          <IonItem slot="header" color="light" className="font-medium">
            <IonIcon icon={bonfire} className="mr-2" />
            <IonLabel className="text-gray-700 dark:text-gray-200">Lesson Plan</IonLabel>
          </IonItem>
          <div className="ion-padding bg-white dark:bg-gray-800" slot="content">
            <IonTextarea
              labelPlacement="stacked"
              fill="outline"
              value={lesson.prompt}
              rows={20}
              className="min-h-[300px] font-mono text-sm"
              onIonChange={e => lesson.prompt = e.detail.value }
            />
          </div>
        </IonAccordion>
        <IonAccordion value="role-setup" className="overflow-hidden shadow-md">
          <IonItem slot="header" color="light" className="font-medium">
            <IonIcon icon={people} className="mr-2" />
            <IonLabel className="text-gray-700 dark:text-gray-200">Conversation Roles</IonLabel>
          </IonItem>
          <div className="ion-padding bg-white dark:bg-gray-800" slot="content">
            <RoleSelector />
          </div>
        </IonAccordion>
        <IonAccordion value="learning-objectives" className="overflow-hidden shadow-md">
          <IonItem slot="header" color="light" className="font-medium">
            <IonIcon icon={apps} className="mr-2" />
            <IonLabel className="text-gray-700 dark:text-gray-200">Learning Objectives</IonLabel>
          </IonItem>
          <div slot="content">
              {(lesson.learning_objectives ?? []).map((objective, index) => (
                <IonItem key={index}>
                  <IonIcon icon={checkmarkCircleOutline} className="text-green-500 text-xl mr-2" />
                  <p className="text-gray-800 dark:text-gray-200">{objective}</p>
                </IonItem>
              ))}
          </div>
        </IonAccordion>
      </IonAccordionGroup>

      <div className="mt-6 flex justify-center">
        <button 
          ref={videoCallRef}
          disabled={videoCallStatus === 'connecting'}
          className={`flex items-center justify-center gap-2 ${
            videoCallStatus === 'idle' ? 'bg-blue-600 hover:bg-blue-700' : 
            videoCallStatus === 'connecting' ? 'bg-gray-500 hover:bg-gray-600' : 
            'bg-red-600 hover:bg-red-700'
          } text-white font-bold py-3 px-6 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105`}
          onClick={toggleVideoCall}
        >
          <IonIcon icon={videocam} className="text-xl" />
          <span>
            {videoCallStatus === 'idle' ? 'Start Video Call' : 
              videoCallStatus === 'connecting' ? 'Connecting...' : 
              'Stop Video Call'}
          </span>
        </button>
      </div>
    </div>
    <div className="max-sm:px-4 px-8 m-auto">
      <div className="mx-1">
        {[...messages].map((msg, key) => (
          <Message key={key} msg={msg} />
        ))}
        <div className='h-20' ref={messagesEndRef} />
      </div>
    </div>
        {(!showAvatarCanvas && videoCallStatus == "active") && 
    <IonFab slot="fixed" vertical="bottom" horizontal="end">
      <IonFabButton>
        <IonIcon icon={happyOutline}></IonIcon>
      </IonFabButton>
      <IonFabList side="top">
        <IonFabButton onClick={() => setShowAvatarCanvas(true)}>
          <IonIcon icon={colorPalette}></IonIcon>
        </IonFabButton>
        <IonFabButton onClick={(e) => {avatarMenuRef.current!.present(e)}}>
          <IonIcon icon={globe}></IonIcon>
        </IonFabButton>
      </IonFabList>
    </IonFab>
    }
  </IonContent>
  <div className="relative">
    {/* relative positioning of the avatar relative to top of the chat box */}
  <canvas onClick={() => {setShowAvatarCanvas(false)}} ref={live2dRef} style={{
    position: "absolute", zIndex: 10,
    pointerEvents: (showAvatarCanvas && videoCallStatus == "active") ? "auto" : "none",
    opacity: (showAvatarCanvas && videoCallStatus == "active") ? 1 : 0,
    // background: "red",
    width: "30vh", height: "85vh", top: "-35vh", right: "0", // haru
    //width: "35vh", height: "70vh", top: "-25vh", right: "0" // cat
  }} />

  <AvatarSettings ref={avatarMenuRef} />
  <IonFab slot="fixed" vertical="bottom" horizontal="center" className='pb-1'>
    {modelSpeaking && (<IonButton onClick={async () => {
      const Live2D = await import('@/controllers/Live2D');
      Live2D.default.stopSpeaking();
      TTS.stopSpeaking();
      setModelSpeaking(false)
    }}>
      Skip
    </IonButton>)}
  </IonFab>
  <Footer onSendMessage={(inputFormat, text) => {
    saveMessage(inputFormat, text);
  }} />
  </div>
  </>);
};

export default Lesson;
